function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Save");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon/save",
  stroke: "#636363"
}, React.createElement("g", {
  id: "Group-9"
}, React.createElement("g", {
  id: "secondary-button-copy-2"
}, React.createElement("rect", {
  id: "Rectangle-Copy-4",
  x: 0.5,
  y: 0.5,
  width: 46,
  height: 39,
  rx: 4
}))), React.createElement("g", {
  id: "save",
  transform: "translate(15.000000, 11.000000)",
  strokeLinecap: "square"
}, React.createElement("path", {
  d: "M14.2928932,0.29289322 L17.1213203,3.12132034 C17.6839295,3.68392948 18,4.44699122 18,5.24264069 L18,17 C18,17.5522847 17.5522847,18 17,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,1 C0,0.44771525 0.44771525,0 1,0 L13.5857864,0 C13.8510029,0 14.1053568,0.10535684 14.2928932,0.29289322 Z",
  id: "Path"
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4,
  y: 10,
  width: 10,
  height: 8
}), React.createElement("path", {
  d: "M5,0 L13,0 L13,4 C13,4.55228475 12.5522847,5 12,5 L6,5 C5.44771525,5 5,4.55228475 5,4 L5,0 Z",
  id: "Rectangle"
})), React.createElement("path", {
  d: "M22.5,12.5 L22.5,14.0857655",
  id: "Line-5",
  strokeLinecap: "square"
})));

const SvgSaveBorder = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "47px",
    height: "40px",
    viewBox: "0 0 47 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSaveBorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/save-border.043dcb8a.svg";
export { ForwardRef as ReactComponent };